/* ═══════════════════════════════════════════════════════════ */
/* ABODE WAREHOUSE — Theme JavaScript                         */
/* ═══════════════════════════════════════════════════════════ */

(function(){
  'use strict';

  /* ── CUSTOM CURSOR removed (v75): the smooth-follow effect lagged behind the
     real pointer and was disorienting, especially on Windows. Native cursor restored. ── */

  /* ── SCROLL REVEAL ── */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  /* ── HEADER SCROLL ── */
  const header = document.querySelector('.header');
  let ticking = false;

  function onScroll() {
    const scrollY = window.scrollY;

    // Header shadow
    if (header) {
      header.classList.toggle('header--scrolled', scrollY > 60);
    }

    // Parallax
    document.querySelectorAll('[data-parallax]').forEach(section => {
      const rect = section.getBoundingClientRect();
      const winH = window.innerHeight;
      const sectionCenter = rect.top + rect.height / 2;
      const offset = sectionCenter - winH / 2;
      const bg = section.querySelector('.parallax-break__bg');
      if (!bg) return;
      const speed = parseFloat(bg.dataset.speed || 0.3);
      bg.style.transform = 'translateY(' + (offset * speed) + 'px)';
    });
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  onScroll();

  /* ── QUANTITY SELECTORS ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.quantity-selector__btn');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var val = parseInt(input.value) || 1;
    if (btn.dataset.action === 'decrease') {
      input.value = Math.max(1, val - 1);
    } else if (btn.dataset.action === 'increase') {
      input.value = val + 1;
    }
    input.dispatchEvent(new Event('change'));
  });

  /* ── PRODUCT IMAGE GALLERY ── */
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.product-page__thumb');
    if (!thumb) return;
    var mainImg = document.getElementById('product-main-image');
    var fullSrc = thumb.dataset.fullSrc;
    if (!mainImg || !fullSrc) return;
    mainImg.style.opacity = '0.3';
    var tempImg = new Image();
    tempImg.onload = function() {
      mainImg.src = fullSrc;
      mainImg.style.opacity = '1';
    };
    tempImg.src = fullSrc;
    thumb.parentElement.querySelectorAll('.product-page__thumb').forEach(function(t) {
      t.classList.remove('product-page__thumb--active');
    });
    thumb.classList.add('product-page__thumb--active');
  });

  /* ── COVERAGE CALCULATOR ── */
  (function() {
    var toggle = document.getElementById('coverage-calc-toggle');
    var body = document.getElementById('coverage-calc-body');
    var calc = document.getElementById('coverage-calc');
    if (!toggle || !body) return;

    toggle.addEventListener('click', function() {
      var open = body.style.display !== 'none';
      body.style.display = open ? 'none' : '';
      calc.classList.toggle('coverage-calc--open', !open);
    });

    var goBtn = document.getElementById('calc-go');
    var applyBtn = document.getElementById('calc-apply');
    if (!goBtn) return;

    goBtn.addEventListener('click', function() {
      var length = parseFloat(document.getElementById('calc-length').value) || 0;
      var width = parseFloat(document.getElementById('calc-width').value) || 0;
      if (length <= 0 || width <= 0) return;

      var unit = calc.getAttribute('data-unit') || 'sq ft';
      var isSqYd = unit === 'sq yd';
      var areaSqFt = length * width;
      var area = isSqYd ? areaSqFt / 9 : areaSqFt;
      var overage = area * 0.10;
      var total = Math.ceil(area + overage);

      // Get price per unit from the page
      var priceEl = document.querySelector('.product-page__price');
      var priceText = priceEl ? priceEl.textContent : '';
      var priceMatch = priceText.match(/[\d.]+/);
      var pricePerUnit = priceMatch ? parseFloat(priceMatch[0]) : 0;
      var estCost = (total * pricePerUnit).toFixed(2);

      var areaDisplay = isSqYd ? area.toFixed(1) : area.toFixed(0);
      var overageDisplay = isSqYd ? overage.toFixed(1) : Math.ceil(overage).toString();
      document.getElementById('calc-area').textContent = areaDisplay + ' ' + unit;
      document.getElementById('calc-overage').textContent = overageDisplay + ' ' + unit;
      document.getElementById('calc-total').textContent = total + ' ' + unit;
      document.getElementById('calc-cost').textContent = '$' + estCost;
      document.getElementById('calc-result').style.display = '';
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        var totalEl = document.getElementById('calc-total');
        var total = parseInt(totalEl.textContent) || 1;
        var qtyInput = document.getElementById('product-qty');
        if (qtyInput) {
          qtyInput.value = total;
          qtyInput.dispatchEvent(new Event('change'));
        }
        // Scroll to the quantity selector
        qtyInput.closest('.quantity-selector').scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  })();

  /* ── PRODUCT QUICK ADD ── */
  document.addEventListener('click', function(e) {
    const quickAdd = e.target.closest('[data-quick-add]');
    if (!quickAdd) return;
    e.preventDefault();

    const variantId = quickAdd.dataset.variantId;
    if (!variantId) return;

    quickAdd.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => {
      quickAdd.textContent = 'Added ✓';
      updateCartCount();
      setTimeout(() => { quickAdd.textContent = 'Quick Add to Cart'; }, 2000);
    })
    .catch(() => {
      quickAdd.textContent = 'Quick Add to Cart';
    });
  });

  /* ── CART COUNT UPDATE ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }

  /* ── PRODUCT FORM SUBMIT ── */
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[type="submit"]');
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(() => {
      btn.textContent = 'Added to Cart ✓';
      updateCartCount();
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2500);
    })
    .catch(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });

})();

/* ── PRODUCT COMPARE ── */
(function() {
  var KEY = 'abode_compare';
  var MAX = 3;

  function getList() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch(e) { return []; }
  }
  function saveList(list) {
    try { sessionStorage.setItem(KEY, JSON.stringify(list)); } catch(e) {}
  }

  function renderBar() {
    var list = getList();
    var bar = document.getElementById('compareBar');
    var items = document.getElementById('compareItems');
    var btn = document.getElementById('compareNow');
    if (!bar || !items) return;

    if (list.length === 0) {
      bar.classList.remove('is-visible');
      bar.style.display = 'none';
      return;
    }

    bar.style.display = '';
    setTimeout(function() { bar.classList.add('is-visible'); }, 10);

    var html = '';
    list.forEach(function(p) {
      html += '<div class="compare-bar__item">' +
        (p.image ? '<img src="' + p.image + '" alt="' + p.title + '">' : '') +
        '<span>' + p.title.substring(0, 25) + (p.title.length > 25 ? '…' : '') + '</span>' +
        '<button class="compare-bar__item-remove" onclick="removeCompare(\'' + p.id + '\')" aria-label="Remove">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button></div>';
    });
    items.innerHTML = html;
    btn.disabled = list.length < 2;

    document.querySelectorAll('.product-card__compare-link').forEach(function(b) {
      var card = b.closest('.product-card');
      if (!card) return;
      var id = card.getAttribute('data-compare-id');
      var inList = list.some(function(p) { return p.id === id; });
      b.classList.toggle('is-active', inList);
      var textEl = b.querySelector('.product-card__compare-link-text');
      if (textEl) textEl.textContent = inList ? 'Comparing' : '+ Compare';
    });
  }

  window.toggleCompare = function(card) {
    if (!card) return;
    var id = card.getAttribute('data-compare-id');
    var list = getList();
    var idx = list.findIndex(function(p) { return p.id === id; });
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      if (list.length >= MAX) {
        alert('You can compare up to ' + MAX + ' products at a time. Remove one first.');
        return;
      }
      list.push({
        id: id,
        title: card.getAttribute('data-compare-title'),
        vendor: card.getAttribute('data-compare-vendor'),
        price: card.getAttribute('data-compare-price'),
        url: card.getAttribute('data-compare-url'),
        image: card.getAttribute('data-compare-image'),
        type: card.getAttribute('data-compare-type')
      });
    }
    saveList(list);
    renderBar();
  };

  window.removeCompare = function(id) {
    var list = getList().filter(function(p) { return p.id !== id; });
    saveList(list);
    renderBar();
  };

  var clearBtn = document.getElementById('compareClear');
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      saveList([]);
      renderBar();
    });
  }

  var compareBtn = document.getElementById('compareNow');
  if (compareBtn) {
    compareBtn.addEventListener('click', function() {
      var list = getList();
      if (list.length < 2) return;
      var modal = document.getElementById('compareModal');
      var body = document.getElementById('compareBody');
      if (!modal || !body) return;

      var specs = ['Type', 'Brand', 'Price'];
      var headerRow = '<tr><td></td>';
      list.forEach(function(p) {
        headerRow += '<th>' +
          (p.image ? '<img src="' + p.image + '" alt="' + p.title + '">' : '') +
          '<span class="compare-table__vendor">' + p.vendor + '</span>' +
          '<span class="compare-table__name">' + p.title + '</span>' +
          '<span class="compare-table__price">' + p.price + ' / sq ft</span>' +
          '<a class="compare-table__cta" href="' + p.url + '">View Product</a>' +
        '</th>';
      });
      headerRow += '</tr>';

      var rows = '';
      rows += '<tr><td>Type</td>';
      list.forEach(function(p) { rows += '<td>' + (p.type || '—') + '</td>'; });
      rows += '</tr>';
      rows += '<tr><td>Brand</td>';
      list.forEach(function(p) { rows += '<td>' + (p.vendor || '—') + '</td>'; });
      rows += '</tr>';
      rows += '<tr><td>Price</td>';
      list.forEach(function(p) { rows += '<td>' + (p.price || '—') + ' / sq ft</td>'; });
      rows += '</tr>';

      body.innerHTML = '<table class="compare-table">' + headerRow + rows + '</table>' +
        '<p style="font-size:12px;color:var(--text-muted);text-align:center;margin-top:16px">For detailed specs, visit each product page.</p>';

      modal.style.display = '';
      document.body.style.overflow = 'hidden';
    });
  }

  var modalClose = document.getElementById('compareModalClose');
  var modalBackdrop = document.getElementById('compareModalBackdrop');
  function closeModal() {
    var modal = document.getElementById('compareModal');
    if (modal) { modal.style.display = 'none'; document.body.style.overflow = ''; }
  }
  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  renderBar();

  /* ── FLOORING CALCULATOR ENGINE (v75) ──────────────────────────────
     Lives in the theme so in-article calculators keep working even though
     Shopify's blog editor strips inline <script> tags on save. The blog
     markup supplies the HTML; this supplies the brain. Math is identical
     to the standalone calculator page. */
  (function() {
    var floorData = {
      lvp:            { waste: 0.08, low: 2.00, high: 5.50,  label: 'LVP',                 wastePct: '8%'  },
      engineered:     { waste: 0.10, low: 4.00, high: 9.00,  label: 'Engineered Hardwood', wastePct: '10%' },
      solid:          { waste: 0.10, low: 6.00, high: 14.00, label: 'Solid Hardwood',      wastePct: '10%' },
      tile:           { waste: 0.10, low: 2.50, high: 8.00,  label: 'Tile',                wastePct: '10%' },
      'tile-diagonal':{ waste: 0.15, low: 2.50, high: 8.00,  label: 'Tile (diagonal)',     wastePct: '15%' },
      carpet:         { waste: 0.12, low: 2.00, high: 6.00,  label: 'Carpet',              wastePct: '12%' }
    };
    function fmt(n)    { return n.toLocaleString('en-US', { maximumFractionDigits: 0 }); }
    function fmtCur(n) { return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 }); }
    function setText(id, val) { var el = document.getElementById(id); if (el) el.textContent = val; }

    window.awAddRoom = function() {
      var rooms = document.getElementById('aw-rooms');
      if (!rooms || rooms.children.length >= 5) return;
      var row = document.createElement('div');
      row.className = 'aw-room-row';
      row.innerHTML = '<input type="number" placeholder="Length" min="1" step="0.5" class="aw-len"><span class="aw-x">×</span><input type="number" placeholder="Width" min="1" step="0.5" class="aw-wid"><span class="aw-ft">ft</span>';
      rooms.appendChild(row);
    };

    window.awCalculate = function() {
      var rows = document.querySelectorAll('#aw-rooms .aw-room-row');
      if (!rows.length) return;
      var rawSF = 0;
      rows.forEach(function(row) {
        var lenEl = row.querySelector('.aw-len'), widEl = row.querySelector('.aw-wid');
        var l = lenEl ? parseFloat(lenEl.value) || 0 : 0;
        var w = widEl ? parseFloat(widEl.value) || 0 : 0;
        rawSF += l * w;
      });
      if (rawSF <= 0) { alert('Please enter at least one room\'s dimensions.'); return; }
      var sel = document.getElementById('aw-floor-select');
      var d = floorData[sel ? sel.value : 'lvp'] || floorData.lvp;
      var adjSF = rawSF * (1 + d.waste);
      var boxes = Math.ceil(adjSF / 22);
      setText('aw-raw-sf', fmt(Math.round(rawSF)));
      setText('aw-adj-sf', fmt(Math.round(adjSF)));
      setText('aw-adj-sf-2', fmt(Math.round(adjSF)));
      setText('aw-boxes', boxes);
      setText('aw-cost-range', fmtCur(adjSF * d.low) + ' – ' + fmtCur(adjSF * d.high));
      setText('aw-waste-note', d.wastePct + ' waste factor applied for ' + d.label + '. Boxes calculated at 22 sq ft per box — check your product page for exact coverage. Installation not included.');
      var res = document.getElementById('aw-results');
      if (res) res.classList.add('visible');
    };
  })();
})();
